/* compoCASE – Mobil-Korrekturen (10.10.2026) */
(function () {
  var root = document.documentElement;

  /* ---------- Bild ganz oben: Produkt immer mittig im Banner (Handy + Desktop) ----------
     Pro Bannerbild: wo liegt das Produkt im Bild (0 = links/oben, 1 = rechts/unten).
     Neues Bannerbild? Einfach eine Zeile ergänzen: 'Teil-des-Dateinamens': [x, y] */
  var FOCUS = {
    'BannerKollektionsseite-2': [0.57, 0.58], /* Kollektionen */
    'IMG_0707_2': [0.61, 0.76],              /* Kontakt */
    'IMG_0769': [0.57, 0.50],                /* Business */
    '__47250': [0.39, 0.49],                 /* FAQ */
    'IMG_0962': [0.48, 0.55],                /* Retoure */
    'Banner_Technik': [0.51, 0.57],          /* Schutz */
    'Banner_About_us': [0.53, 0.63]          /* Über uns */
  };
  function focusOf(img) {
    var src = img.currentSrc || img.src || '';
    for (var k in FOCUS) { if (src.indexOf(k) !== -1) return FOCUS[k]; }
    return null;
  }
  function centerImg(img) {
    var f = focusOf(img);
    if (!f || !img.naturalWidth) return;
    var bw = img.clientWidth, bh = img.clientHeight;
    if (!bw || !bh) return;
    var s = Math.max(bw / img.naturalWidth, bh / img.naturalHeight);
    var w = img.naturalWidth * s, h = img.naturalHeight * s;
    var x = bw / 2 - f[0] * w, y = bh / 2 - f[1] * h;
    x = Math.min(0, Math.max(bw - w, x));
    y = Math.min(0, Math.max(bh - h, y));
    img.style.setProperty('object-position', Math.round(x) + 'px ' + Math.round(y) + 'px', 'important');
  }
  function heroImages() {
    var main = document.getElementById('MainContent');
    if (!main) return [];
    var first = main.querySelector(':scope > .shopify-section');
    return first ? [].slice.call(first.querySelectorAll('.banner__media img')) : [];
  }
  function centerBanners() {
    var imgs = heroImages();
    if (!imgs.length) return;
    function all() { imgs.forEach(centerImg); }
    imgs.forEach(function (img) {
      if (img.complete) centerImg(img);
      img.addEventListener('load', function () { centerImg(img); });
    });
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(all, 100); }, { passive: true });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(all);
      imgs.forEach(function (img) { ro.observe(img); });
    }
    window.addEventListener('load', all);
  }

  /* ---------- Gravur-Seite: Gravur-Fotos statt technischer Details ---------- */
  var GRAVUR_FOTOS = [
    ['compocase-gravur-initialen-m3-soft-rose.jpg?v=1791646274', 'Initialen', 'Soft Rose', 'compoCASE Handyhülle in Soft Rose mit gravierten Initialen M³'],
    ['compocase-gravur-initialen-ms-midnight-black.jpg?v=1791646275', 'Initialen', 'Midnight Black', 'compoCASE Handyhülle in Midnight Black mit gravierten Initialen M|S'],
    ['compocase-gravur-motiv-berg-forest-green.jpg?v=1791646274', 'Eigenes Motiv', 'Forest Green', 'compoCASE Handyhülle in Forest Green mit graviertem Bergmotiv'],
    ['compocase-gravur-motiv-wildtiere-midnight-black.jpg?v=1791646275', 'Eigenes Motiv', 'Midnight Black', 'compoCASE Handyhülle in Midnight Black mit graviertem Motiv aus Fuchs, Hirsch und Wildschwein'],
    ['compocase-gravur-motiv-herz-i-mog-di-arctic-blue.jpg?v=1791646274', 'Eigenes Motiv', 'Arctic Blue', 'compoCASE Handyhülle in Arctic Blue mit graviertem Lebkuchenherz']
  ];
  var CDN = 'https://cdn.shopify.com/s/files/1/0946/6252/5273/files/';
  /* Diese Bild-Banner (Haptik, Alltag, Details) entfallen auf der Gravur-Seite */
  var GRAVUR_OHNE = ['__image_banner_gxnPze', '__image_banner_fqVazY', '__image_banner_jWypCA'];

  function gravurPage() {
    var ccx = document.getElementById('ccx');
    if (!ccx) return;
    var main = document.getElementById('MainContent');
    if (main) {
      [].slice.call(main.children).forEach(function (sec) {
        GRAVUR_OHNE.forEach(function (id) { if (sec.id && sec.id.slice(-id.length) === id && sec.parentNode) sec.parentNode.removeChild(sec); });
      });
    }
    /* Reiter „Technische Daten“ entfernen – hier geht es nur um die Gravur */
    var tabs = document.getElementById('cc-tabs');
    if (tabs) {
      [].slice.call(tabs.querySelectorAll('.cc-tabs__item')).forEach(function (it) {
        var b = it.querySelector('.cc-tabs__acc');
        if (b && /Technische Daten/i.test(b.textContent)) it.parentNode.removeChild(it);
      });
      [].slice.call(tabs.querySelectorAll('.cc-tabs__tab')).forEach(function (b) {
        if (/Technische Daten/i.test(b.textContent)) b.parentNode.removeChild(b);
      });
    }
    if (document.getElementById('ccg')) return;
    var host = ccx.closest('.shopify-section');
    if (!host) return;
    var html = '<section class="ccg" aria-labelledby="ccg-title"><div class="ccg__head">' +
      '<h2 id="ccg-title">So sieht deine Gravur in echt aus.</h2>' +
      '<p>Jede Gravur wird per Laser direkt ins Material gearbeitet.</p></div><div class="ccg__grid">';
    GRAVUR_FOTOS.forEach(function (f, i) {
      var u = CDN + f[0];
      var set = [400, 600, 900, 1200].map(function (w) { return u + '&width=' + w + ' ' + w + 'w'; }).join(', ');
      html += '<figure class="ccg__item"><div class="ccg__media"><img src="' + u + '&width=900" srcset="' + set + '" sizes="' +
        (i === 0 ? '(min-width: 750px) 50vw, 78vw' : '(min-width: 750px) 25vw, 78vw') +
        '" alt="' + f[3].replace(/"/g, '&quot;') + '" loading="lazy" decoding="async" width="1536" height="1536"></div>' +
        '<figcaption><strong>' + f[1] + '</strong> · ' + f[2] + '</figcaption></figure>';
    });
    html += '</div><p class="ccg__note">Eigenes Motiv? Lade es im Konfigurator einfach als Logo hoch.</p></section>';
    var wrap = document.createElement('div');
    wrap.className = 'shopify-section cc-gravur-echt';
    wrap.id = 'ccg';
    wrap.innerHTML = html;
    host.parentNode.insertBefore(wrap, host.nextSibling);
  }

  /* ---------- Startseite: Bild im Karten-Banner „Dein CASE. Deine Gravur.“ ----------
     Zeigt das Foto M|S, solange im Theme noch IMG_0720 gesetzt ist. */
  function homeBanners() {
    var img = document.querySelector('[id$="__image_banner_peidPz"] .banner__media img[src*="IMG_0720"]');
    if (!img) return;
    var u = CDN + 'compocase-gravur-initialen-ms-midnight-black.jpg?v=1791646275';
    img.srcset = [600, 900, 1200, 1536].map(function (w) { return u + '&width=' + w + ' ' + w + 'w'; }).join(', ');
    img.src = u + '&width=1536';
    img.alt = 'compoCASE Handyhülle in Midnight Black mit gravierten Initialen M|S';
  }

  /* ---------- Unternehmensseite ----------
     1) Banner „Individuelles Business-Set“ zeigt das neue Set-Foto, solange im Theme noch IMG_0765 gesetzt ist.
     2) Spenden-Rechner: Regler-Bereich und Ergebnis-Bereich gleich breit (Desktop). */
  function businessPage() {
    var img = document.querySelector('[id$="__image_banner_K9iiHr"] .banner__media img[src*="IMG_0765"]');
    if (img) {
      var u = CDN + 'compocase-business-set-case-compostrap-charger-logo-gravur.jpg?v=1791984152';
      img.srcset = [750, 1100, 1500, 2000, 2400].map(function (w) { return u + '&width=' + w + ' ' + w + 'w'; }).join(', ');
      img.src = u + '&width=1500';
      img.alt = 'Business-Set mit compoCASE Handyhülle, compoSTRAP Short und Long und Wood Wireless Charger, jeweils mit graviertem Beispiel-Logo';
    }
    if (document.querySelector('[id$="__custom_liquid_GDTGft"]') && !document.getElementById('cc-donate-fix')) {
      var st = document.createElement('style');
      st.id = 'cc-donate-fix';
      st.textContent = '@media screen and (min-width: 990px){' +
        '[id$="__custom_liquid_GDTGft"] [class$="__grid"]{grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;gap:64px!important;align-items:center!important}' +
        '[id$="__custom_liquid_GDTGft"] [class$="__qty-col"]{width:100%}' +
        '[id$="__custom_liquid_GDTGft"] [class$="__notes"],[id$="__custom_liquid_GDTGft"] [class$="__notes"] *{white-space:normal!important}' +
        '}';
      document.head.appendChild(st);
    }
  }

  /* Startseite: Karten-Banner ausblenden, sobald der Bereich danach sie ganz überdeckt */
  var guardOn = false;
  function cardsGuard() {
    if (guardOn) return true;
    var after = document.querySelector('.cc-after-first');
    if (!after) return false;
    guardOn = true;
    var ticking = false;
    function update() {
      ticking = false;
      root.classList.toggle('cc-past-cards', after.getBoundingClientRect().top < 0);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
    return true;
  }

  /* ---------- Videos: stumm, im Bild abspielen, sofort starten ---------- */
  function silent(v) {
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('disablepictureinpicture', '');
    v.setAttribute('disableremoteplayback', '');
  }
  function play(v) {
    if (!v.paused || document.hidden) return;
    silent(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* Video oben auf der Startseite: sofort starten.
     Das zweite Video lädt erst, wenn das erste läuft (spart beim Aufruf ca. 1,6 MB). */
  function heroVideo() {
    var vids = document.querySelectorAll('.jd-hero__video');
    if (!vids.length) return;
    vids.forEach(silent);
    var first = vids[0];
    var rest = [].slice.call(vids, 1);
    rest.forEach(function (v) {
      if (v.paused && v.currentTime === 0 && v.preload !== 'none') {
        v.preload = 'none';
        try { v.load(); } catch (e) {}
      }
    });
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      rest.forEach(function (v) {
        if (v.paused && v.currentTime === 0) { v.preload = 'auto'; try { v.load(); } catch (e) {} }
        else v.preload = 'auto';
      });
    }
    first.addEventListener('timeupdate', function () { if (first.currentTime > 2) warm(); });
    first.addEventListener('ended', warm);
    first.addEventListener('error', warm, true);
    setTimeout(warm, 15000);

    var hero = first.closest('.jd-hero');
    var slide = first.closest('.jd-hero__slide');
    function tryPlay() {
      var activeFirst = !hero || !hero.classList.contains('is-ready') || (slide && slide.classList.contains('is-active'));
      if (activeFirst && first.getBoundingClientRect().bottom > 0) play(first);
    }
    ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'suspend'].forEach(function (e) { first.addEventListener(e, tryPlay); });
    window.addEventListener('pageshow', tryPlay);
    window.addEventListener('load', tryPlay);
    document.addEventListener('visibilitychange', tryPlay);
    [0, 300, 800, 1500, 3000].forEach(function (ms) { setTimeout(tryPlay, ms); });
    /* Falls der Browser Autoplay blockiert: bei der ersten Berührung / Bewegung starten */
    ['touchstart', 'touchend', 'pointerdown', 'scroll', 'keydown'].forEach(function (e) {
      window.addEventListener(e, tryPlay, { passive: true });
    });
    if (first.readyState >= 2) tryPlay();
  }

  /* Video-Abschnitte (z. B. Material-Seite): statt Vorschaubild mit Play-Knopf
     läuft das Video automatisch, stumm und in Schleife – sobald es im Bild ist. */
  function sectionVideos() {
    [].slice.call(document.querySelectorAll('.video-section deferred-media')).forEach(function (dm) {
      if (dm.getAttribute('data-cc-auto')) return;
      var tpl = dm.querySelector('template');
      if (!tpl || !tpl.content) return;
      var tv = tpl.content.querySelector('video');
      var src = tv && tv.querySelector('source');
      if (!src) return; /* nur Shopify-Videos, nicht YouTube/Vimeo */
      dm.setAttribute('data-cc-auto', '1');
      var v = document.createElement('video');
      silent(v);
      v.loop = true;
      v.autoplay = true;
      v.preload = 'metadata';
      v.controls = false;
      if (tv.getAttribute('poster')) v.poster = tv.getAttribute('poster');
      v.setAttribute('aria-label', (dm.querySelector('[aria-label]') || {}).getAttribute ? dm.querySelector('[aria-label]').getAttribute('aria-label').replace(/^Video laden:\s*/, '') : 'Video');
      v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;border:0;';
      var s = document.createElement('source');
      s.src = src.getAttribute('src');
      s.type = src.getAttribute('type') || 'video/mp4';
      v.appendChild(s);
      var poster = dm.querySelector('.deferred-media__poster');
      if (poster) poster.style.display = 'none';
      dm.appendChild(v);
      dm.setAttribute('loaded', 'true');

      var inView = false;
      function tryPlay() { if (inView) play(v); }
      ['loadedmetadata', 'loadeddata', 'canplay'].forEach(function (e) { v.addEventListener(e, tryPlay); });
      document.addEventListener('visibilitychange', tryPlay);
      ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (e) {
        window.addEventListener(e, tryPlay, { passive: true });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          inView = es[0].isIntersecting;
          if (inView) { if (v.preload !== 'auto') v.preload = 'auto'; tryPlay(); }
          else if (!v.paused) v.pause();
        }, { threshold: 0.2 }).observe(dm);
      } else {
        inView = true;
        v.preload = 'auto';
        tryPlay();
      }
    });
  }

  function init() {
    gravurPage();
    homeBanners();
    businessPage();
    centerBanners();
    heroVideo();
    sectionVideos();
    var tries = 0;
    (function retry() {
      if (cardsGuard() || ++tries > 20) return;
      setTimeout(retry, 250);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ============================================================
   compoCASE – Ergänzungen 19.10.2026
   1) Startseite: keine Lücke unter den Bewertungen (Banner scheint sonst durch)
   2) Produktseiten Desktop: Pfeile auf dem großen Bild zum Weiterklicken
   3) Zurück-Button: man landet wieder an der Stelle, an der man war
   ============================================================ */
(function () {
  var css =
    '#MainContent > .shopify-section:has(.jdgm-carousel-wrapper){display:flow-root}' +
    '.cc-gal-arrow{display:none}' +
    '@media screen and (min-width:750px){' +
      '.cc-gal-host{position:relative}' +
      '.cc-gal-arrow{display:flex;align-items:center;justify-content:center;position:absolute;top:50%;z-index:3;width:44px;height:44px;margin-top:-22px;padding:0;border-radius:50%;border:1px solid rgba(28,34,40,.12);background:rgba(255,255,255,.92);color:#1C2228;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.06);transition:background-color .2s ease,transform .2s ease}' +
      '.cc-gal-arrow:hover{background:#fff;transform:scale(1.04)}' +
      '.cc-gal-arrow:focus-visible{outline:2px solid #1C2228;outline-offset:2px}' +
      '.cc-gal-arrow--prev{left:16px}' +
      '.cc-gal-arrow--next{right:16px}' +
      '.cc-gal-arrow svg{width:16px;height:16px;display:block}' +
      '.cc-gal-host.cc-gal-single .cc-gal-arrow{display:none}' +
    '}';
  var st = document.createElement('style');
  st.id = 'cc-extra-1910';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  /* 2) Galerie-Pfeile */
  function galleryArrows() {
    document.querySelectorAll('media-gallery').forEach(function (g) {
      if (g.getAttribute('data-cc-arrows')) return;
      if (!/thumbnail/.test(g.getAttribute('data-desktop-layout') || '')) return;
      var viewer = g.querySelector('slider-component[id^="GalleryViewer"]');
      var list = viewer && viewer.querySelector('ul');
      if (!list) return;
      g.setAttribute('data-cc-arrows', '1');
      viewer.classList.add('cc-gal-host');
      function visible() {
        return [].filter.call(list.querySelectorAll(':scope > li[data-media-id]'), function (li) {
          return !li.classList.contains('cc-hide');
        });
      }
      function refresh() { viewer.classList.toggle('cc-gal-single', visible().length < 2); }
      function go(dir) {
        var v = visible();
        if (v.length < 2) return;
        var i = -1;
        v.forEach(function (li, k) { if (li.classList.contains('is-active')) i = k; });
        var n = v[(i + dir + v.length) % v.length];
        if (typeof g.setActiveMedia === 'function') g.setActiveMedia(n.getAttribute('data-media-id'), false);
      }
      [['prev', -1, 'Vorheriges Bild', 'M10 3 5 8l5 5'], ['next', 1, 'Nächstes Bild', 'M6 3l5 5-5 5']].forEach(function (a) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-gal-arrow cc-gal-arrow--' + a[0];
        b.setAttribute('aria-label', a[2]);
        b.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + a[3] + '"/></svg>';
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(a[1]); });
        viewer.appendChild(b);
      });
      refresh();
      if ('MutationObserver' in window) {
        new MutationObserver(refresh).observe(list, { childList: true, subtree: false, attributes: true, attributeFilter: ['class'] });
      }
    });
  }

  /* 3) Scroll-Position merken und beim Zurückgehen wiederherstellen */
  function scrollMemory() {
    var ss;
    try { ss = window.sessionStorage; ss.setItem('cc-t', '1'); ss.removeItem('cc-t'); } catch (e) { return; }
    function key() { return 'cc-scroll:' + location.pathname + location.search; }
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    function save() {
      try { ss.setItem(key(), String(Math.round(window.scrollY || window.pageYOffset || 0))); } catch (e) {}
    }
    var t;
    var restoring = false;
    window.addEventListener('scroll', function () {
      if (restoring) return;
      clearTimeout(t);
      t = setTimeout(save, 200);
    }, { passive: true });
    window.addEventListener('pagehide', function () { if (!restoring) save(); });

    var nav = '';
    try {
      var en = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      nav = en ? en.type : (performance.navigation && performance.navigation.type === 2 ? 'back_forward' : '');
    } catch (e) {}
    if (nav !== 'back_forward') return;
    var y = parseInt(ss.getItem(key()), 10);
    if (!(y > 0)) return;

    restoring = true;
    var tries = 0;
    function stop() { restoring = false; }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
      window.addEventListener(ev, stop, { passive: true, once: true });
    });
    function go() {
      if (!restoring) return;
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var target = Math.min(y, max);
      if (window.ccLenis && typeof window.ccLenis.scrollTo === 'function') {
        try { window.ccLenis.scrollTo(target, { immediate: true, force: true }); } catch (e) { window.scrollTo(0, target); }
      } else {
        window.scrollTo(0, target);
      }
      var cur = window.scrollY || window.pageYOffset || 0;
      if (Math.abs(cur - y) > 4 && ++tries < 30) setTimeout(go, 120);
      else setTimeout(stop, 300);
    }
    go();
    window.addEventListener('load', function () { tries = Math.min(tries, 20); setTimeout(go, 30); });
  }

  scrollMemory();
  function init() {
    galleryArrows();
    setTimeout(galleryArrows, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
